import {
  SearchCardArea,
  TrackingDataProps,
} from '../../../../../../common/AnalyticsContext/LinkTracking';
import { OpaqueUrl } from '../../../../../../common/routing/util';
import { CardHeading, StyledLink } from './ProfileName.styles';

type Props = TrackingDataProps & {
  children: string;
  href: OpaqueUrl;
};

export const ProfileName = ({ children, href, trackingData }: Props) => (
  <CardHeading h2 title={children}>
    <StyledLink to={href} trackingData={{ ...trackingData, searchCardArea: SearchCardArea.INFO }}>
      {children}
    </StyledLink>
  </CardHeading>
);
